"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePickerKeyboard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var pickers_1 = require("@material-ui/pickers");
var styles_1 = __importDefault(require("./styles"));
var TimePickerKeyboard = function (_a) {
    var id = _a.id, label = _a.label, enclosed = _a.enclosed, _b = _a.format, format = _b === void 0 ? 'hh:mm aa' : _b, // TODO: extend this to use the types from date preference
    _c = _a.margin, // TODO: extend this to use the types from date preference
    margin = _c === void 0 ? 'dense' : _c, _d = _a.variant, variant = _d === void 0 ? 'inline' : _d, _e = _a.value, value = _e === void 0 ? null : _e, // value must be undefined, treated like default value
    _f = _a.onChange, // value must be undefined, treated like default value
    onChange = _f === void 0 ? function () { } : _f, // onChange must be defined
    _g = _a.fixedLabel, // onChange must be defined
    fixedLabel = _g === void 0 ? true : _g, _h = _a.placeholder, placeholder = _h === void 0 ? 'HH:MM aa' : _h, rest = __rest(_a, ["id", "label", "enclosed", "format", "margin", "variant", "value", "onChange", "fixedLabel", "placeholder"]);
    var classes = (0, styles_1.default)({ fixedLabel: fixedLabel });
    return ((0, jsx_runtime_1.jsx)(pickers_1.MuiPickersUtilsProvider, __assign({ utils: date_fns_1.default }, { children: (0, jsx_runtime_1.jsx)(pickers_1.KeyboardTimePicker, __assign({ id: id, label: label, margin: margin, variant: variant, value: value, onChange: function (date) { return onChange(date); }, role: "timer", mask: "__:__ _M", format: format, InputLabelProps: {
                shrink: fixedLabel,
            }, className: classes.root, placeholder: placeholder }, rest)) })));
};
exports.TimePickerKeyboard = TimePickerKeyboard;
